"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var link_1 = require("spry-react/Link/link");
var ShowMoreList = /** @class */ (function (_super) {
    __extends(ShowMoreList, _super);
    function ShowMoreList(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleListExpansion = function () {
            _this.setState({
                isExpanded: !_this.state.isExpanded
            });
        };
        _this.state = {
            isExpanded: false
        };
        return _this;
    }
    ShowMoreList.prototype.render = function () {
        var children = this.props.children;
        /* note: defaultProps will ensure initialDisplayedItemsCount is not undefined */
        var itemsToDisplay = this.props.initialDisplayedItemsCount;
        var showingAll = this.state.isExpanded;
        var shouldShowLink = children.length > itemsToDisplay;
        var items = showingAll
            ? children
            : arrayExtensions_1.first(children, itemsToDisplay);
        var linkMessage = showingAll
            ? "Show fewer " + this.props.nounPlural
            : "Show all " + children.length + " " + this.props.nounPlural;
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: 'list-unstyled' }, items),
            shouldShowLink
                ? React.createElement(link_1.Link, { className: 'l-box-vt-1-4x', style: { display: 'block' }, onClick: this.toggleListExpansion }, linkMessage)
                : null));
    };
    ShowMoreList.defaultProps = {
        initialDisplayedItemsCount: 3
    };
    return ShowMoreList;
}(React.Component));
exports.ShowMoreList = ShowMoreList;
